import * as Icon from "react-bootstrap-icons";
import React from "react";

export default function OrderDirection({sort, current})
{
    return (<>
            {sort &&  sort.field == current && sort.direction == 'ASC' &&
                <Icon.ArrowDown/>}{sort && sort.field == current && sort.direction == 'DESC' &&
            <Icon.ArrowUp/>}</>
    );
}